import {NgModule} from '@angular/core';
import {OwnerFormComponent} from './owner-form.component';
import {OwnerService} from './owner.service';
import {OwnerOverviewComponent} from './owner-overview.component';
import {SharedModule} from '../shared/shared.module';
import {OwnerDatatableComponent} from './owner-datatable.component';
import {ContactModule} from '../contact/contact.module';
import {OwnerContactFormComponent} from './owner-contact-form.component';

@NgModule({
  declarations: [
    OwnerFormComponent,
    OwnerOverviewComponent,
    OwnerDatatableComponent,
    OwnerContactFormComponent
  ],
  exports: [
    OwnerFormComponent,
    OwnerOverviewComponent,
    OwnerDatatableComponent
  ],
  imports: [
    SharedModule,
    ContactModule
  ],
  providers: [
    OwnerService
  ]
})
export class OwnerModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/owner/owner.module.ts